<template>
    <div class="row wrapper">
        <div class="image_login col-lg-7">
            <div class="container">
                <img src="../assets/image/login-img.png" class="login_img" alt="">
            </div>
        </div>
        <div class="login_form col-lg-5 my-auto">
            <div class="container">
                <h1 class="title">
                    Create an Account
                </h1>

                <div class="spacer-md"></div>
                
                <form name="form" @submit.prevent="handleRegister">
                    <div class="form-group">
                        <div v-if="message" class="alert alert-danger" role="alert">{{message.message}}</div>
                    </div>
                    <div class="form-group">
                        <div v-if="success" class="alert alert-success" role="alert">
                            {{success}}<br>
                            <div>
                                <span class="resend" @click="handleResend()">Click here</span>
                                if you haven't recieved an email.
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-sm-6">
                            <div class="input">
                                <input type="text" v-model="first_name" v-validate="'required'" name="first_name" data-vv-as="first name" class="form-control" placeholder="First Name">
                                <i class='bx bx-user'></i>
                            </div>
                            <div v-if="submitted && errors.has('first_name')" class="text-danger">
                                {{errors.first('first_name')? 'First Name Required' :''}}
                            </div>
                            <div v-if="submitted && validation.first_name" class="text-danger">
                                {{validation.first_name[0]}}
                            </div>
                        </div>
                        <div class="form-group col-sm-6">
                            <div class="input">
                                <input type="text" v-model="last_name" v-validate="'required'" name="last_name" data-vv-as="last name" class=" form-control" placeholder="Last Name">
                                <i class='bx bx-user'></i>
                            </div>
                            <div v-if="submitted && errors.has('last_name')" class="text-danger">
                                {{errors.first('last_name')? 'Last Name Required' :''}}
                            </div>
                            <div v-if="submitted && validation.last_name" class="text-danger">
                                {{validation.last_name[0]}}
                            </div>
                        </div>
                    </div>
                    <!-- <div class="form-group">
                        <div class="input">
                            <input type="text" v-model="name" v-validate="'required'" name="name" class="form-control" placeholder="Full Name">
                            <i class='bx bx-user'></i>
                        </div>
                        <div v-if="submitted && errors.has('name')" class="text-danger">
                            {{errors.first('name')}}
                        </div>
                        <div v-if="submitted && validation.name" class="text-danger">
                            {{validation.name[0]}}
                        </div>
                    </div> -->
                    
                    <div class="form-group">
                        <div class="input">
                            <input type="text" v-model="username" v-validate="'required'" name="username" class="form-control" placeholder="Username">
                            <i class='bx bx-user'></i>
                        </div>
                        <div v-if="submitted && errors.has('username')" class="text-danger">
                            {{errors.first('username')? 'Username Required' :''}}
                        </div>
                        <div v-if="submitted && validation.username" class="text-danger">
                            {{validation.username[0]}}
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="input">
                            <input type="email" v-model="email" v-validate="'required|email|max:50'" name="email" class="form-control" placeholder="Email">
                            <i class='bx bx-envelope'></i>
                        </div>
                        <div v-if="submitted && errors.has('email')" class="text-danger">
                            {{errors.first('email')? 'Email Required' :''}}
                        </div>
                        <div v-if="submitted && validation.email" class="text-danger">
                            {{validation.email[0]}}
                        </div>
                    </div>
                    
                    <div class="form-group">
                        <div class="input">
                            <input type="password" v-model="password" v-validate="'required|min:6|max:40'" ref="password" name="password" class="form-control field-password" placeholder="Password">
                            <i class='bx bx-lock'></i>
                            <div class="input-group-append show_pass">
                                <span class="input-group-text"><i @click="showPassword" class="eye-icon bi bi-eye"></i></span>
                            </div>
                        </div>
                        <div v-if="submitted && errors.has('password')" class="text-danger">
                            {{errors.first('password')?'Password Required':''}}
                        </div>
                        <div v-if="submitted && validation.password" class="text-danger">
                            {{validation.password[0]}}
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="input">
                            <input type="password" v-model="password_confirmation" v-validate="'required|confirmed:password'" data-vv-as="password" name="password_confirmation" class="form-control field-password2" placeholder="Password Confirmation">
                            <i class='bx bx-lock'></i>
                            <div class="input-group-append show_pass2">
                                <span class="input-group-text"><i @click="showPasswordC" class="eye-icon bi bi-eye eye_open"></i></span>
                            </div>
                        </div>
                        <div v-if="submitted && password_confirmation == ''" class="text-danger">
                            Password Confirmation Required
                        </div>
                        <div v-else-if="submitted && errors.has('password_confirmation')" class="text-danger">
                            {{errors.first('password_confirmation')}}
                        </div>
                        <div v-if="submitted && validation.password_confirmation" class="text-danger">
                            {{validation.password_confirmation[0]}}
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="input">
                            <input type="text" v-model="referral_code" name="email" :disabled="$route.query.ref" class="form-control referral_input" placeholder="Referral (optional)">
                            <i class='bx bx-user-plus'></i>
                        </div>
                        <div v-if="submitted && errors.has('referral_code')" class="text-danger">
                            {{errors.first('referral_code')}}
                        </div>
                        <div v-if="submitted && validation.referral" class="text-danger">
                            {{validation.referral[0]}}
                        </div>
                    </div>

                    <!-- <div class="d-flex justify-content-beetwen my-3"> -->
                        <!-- <div class="form-check"> -->
                            <!-- <input class="form-check-input" type="checkbox" value="" v-model="checked" id="flexCheckDefault">
                            <label class="form-check-label" for="flexCheckDefault">
                                I Agree to the <a href="" data-toggle="modal" data-target="#termsModal" class="text-danger text-decoration-none">Term and Condition</a>
                                and <a href="#" data-toggle="modal" data-target="#privacyModal" class="text-danger text-decoration-none">Privacy Policy</a>
                            </label> -->
                            <!-- <label class="form-check-label" for="flexCheckDefault" v-b-modal.modal-1>
                                I Agree to the <router-link to="#" class="text-danger text-decoration-none">Term and Condition</router-link>
                                and <router-link to="#" class="text-danger text-decoration-none">Privacy Policy</router-link>
                            </label> -->
                            <!-- <b-modal id="modal-1" scrollable title="Term And Condition"
                            :ok-disabled="scrollbottom"
                            :cancel-disabled="scrollbottom"
                            @cancel="resetModal"
                            @ok="handleOk"
                            >
                            <div class="div-modal" @scroll="onScroll">
                                <p class="my-4">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum</p>
                            </div>
                                
                                
                            </b-modal> -->
                        <!-- </div> -->
                    <!-- </div> -->
                    <button class="btn btn_red btn-block" :disabled="loading">
                        <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                        <!-- <img src="../assets/image/login_icon.svg" class="mr-2" alt=""> -->
                        <span v-show="!loading">Register</span>
                    </button>
                </form>
                <div class="create_acc my-3">
                    <p class="text-secondary">Already have an account?
                        <router-link to="/login" class="text-danger text-decoration-none">Login</router-link>
                    </p>
                </div>
                <div class="create_acc my-3">
                    <p class="text-secondary">Download our guideline for 
                        <a href="https://drive.google.com/file/d/1yI_1AFFpIkQy7wJ-RNQFyGPBe9rh9YTh/view?usp=share_link" target="_blank" class="text-danger text-decoration-none">web</a> and 
                        <a href="https://drive.google.com/file/d/1yI_1AFFpIkQy7wJ-RNQFyGPBe9rh9YTh/view?usp=share_link" target="_blank" class="text-danger text-decoration-none">mobile</a> platform.
                    </p>
                </div>
                
            </div>
            <div class="modal fade" id="termsModal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div class="modal-content">
                        <div class="modal-body">
                            <div class="d-flex language">
                                <p href="" @click="changeLanguage('indonesia')" :class="datacountry === 'indonesia' ? 'activecountry' : ''"> ID </p>
                                <span> / </span>
                                <p href="" @click="changeLanguage('usa')" :class="datacountry === 'usa' ? 'activecountry' : ''"> EN </p>
                            </div>
                            <!-- <button type="button" class="language pt-2">
                                <img src="../assets/language.svg" alt="">
                            </button> -->
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <TermsCondition v-if="datacountry === 'indonesia'" />
                            <TermsConditionEn v-else-if="datacountry === 'usa'" />
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" v-model="checked" id="flexCheckDefault">
                                <label class="form-check-label" for="flexCheckDefault">
                                    I Agree to the Term and Condition
                                </label>
                            </div>
                            <div class="text-center">
                                <button type="button" @click="nextStep()" :disabled="!checked" class="btn btn_red">
                                    <!-- <span v-show="loading2" class="spinner-border spinner-border-sm"></span> -->
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="privacyModal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div class="modal-content">
                        <div class="modal-body">
                            <div class="d-flex language">
                                <p href="" @click="changeLanguage('indonesia')" :class="datacountry === 'indonesia' ? 'activecountry' : ''">ID </p>
                                <span> / </span>
                                <p href="" @click="changeLanguage('usa')" :class="datacountry === 'usa' ? 'activecountry' : ''"> EN </p>
                            </div>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <Privacy v-if="datacountry === 'indonesia'" />
                            <PrivacyEn v-else-if="datacountry === 'usa'" />
                            <form action="" @submit.prevent="postData()">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" v-model="checkedPrivacy" id="privacy">
                                    <label class="form-check-label" for="privacy">
                                        I Agree to the Privacy Policy
                                    </label>
                                </div>
                                <div class="text-center mt-3">
                                    <button type="button" class="btn btn_light me-2" @click="backStep()">Back</button>
                                    <button type="submit" :disabled="!checkedPrivacy || loading2" class="btn btn_red">
                                        <span v-show="loading2" class="spinner-border spinner-border-sm"></span>
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'
import $ from 'jquery'
import Privacy from '../components/Privacy.vue'
import PrivacyEn from '../components/PrivacyEn.vue'
import TermsCondition from '../components/TermsCondition.vue'
import TermsConditionEn from '../components/TermsConditionEn.vue'

export default {
    name: 'Login',
    components: {
        Privacy,
        PrivacyEn,
        TermsCondition,
        TermsConditionEn,
    },
    data(){
        return{
            // user: new User('', ''),
            datacountry: 'indonesia',
            first_name: '',
            last_name: '',
            // name: '',
            username: '',
            email: '',
            password: '',
            password_confirmation: '',
            referral_code: this.$route.query.ref !== ('' || null || 'null' || 'NULL' | 'Null') ? this.$route.query.ref :'',
            submitted: false,
            successful: false,
            message: '',
            success: '',
            validation: '',
            checked : false,
            checkedPrivacy : false,
            loading: false,
            loading2: false,
            scrollbottom: true,
        };
    },
    computed: {
        loggedIn() {
            return this.$store.state.auth.status.loggedIn;
        }
    },
    created() {
        if(this.loggedIn){
            this.$router.push('/dash');
        }
    },
    methods: {
        onScroll(e) {
        const { scrollTop, offsetHeight, scrollHeight } = e.target
        if ((scrollTop + offsetHeight) >= scrollHeight) {
            this.scrollbottom = false
        }
        },
        handleOk(){
            this.checked=true
        },
        resetModal(){
            this.checked=false
        },
        changeLanguage(data){
            this.datacountry = data
        },
        showPassword() {
            const input = document.querySelector('.field-password')
            const show = document.querySelector('.eye-icon')
            if(input.type === 'password') {
                show.classList.remove('bi-eye')
                show.classList.add("bi-eye-slash")
                input.type = 'text'
            } else {
                show.classList.remove("bi-eye-slash")
                show.classList.add('bi-eye')
                input.type = 'password'
            }
        },
        showPasswordC() {
            const input = document.querySelector('.field-password2')
            const show = document.querySelector('.eye_open')
            if(input.type === 'password') {
                show.classList.remove('bi-eye')
                show.classList.add("bi-eye-slash")
                input.type = 'text'
            } else {
                show.classList.remove("bi-eye-slash")
                show.classList.add('bi-eye')
                input.type = 'password'
            }
        },
        handleResend(){
            var url = window.location.origin+process.env.VUE_APP_PUBLIC_PATH+`login`
            axios.get(`investor/${localStorage.resend_id}/resend-email-verification/?verification_redirect_success=${url}&verification_redirect_fail=${url}`)
            .then((response) => {
                // console.log('Resend: ', response);
                swal('Email has been send', response.data.message, 'success', {
					button: "OK"
				})
            }).catch((err) => {
                // console.log(err.response);
                swal('Sorry,,,,', err.response.data.message, 'error', {
					button: "OK"
				})
            })
        },
        handleRegister(){
            this.message = '';
            this.submitted = true;
            // this.loading = true;

            
            this.$validator.validate().then(isValid => {
                if(isValid) {
                    this.loading = true
                    
                    $('#termsModal').modal('show')
                    this.loading = false
                    
                // this.$store.dispatch('auth/register', data).then(
                //   result => {
                //     this.message = result.message;
                //     this.successful = true;
                //     this.$router.push('login');
                //   },
                //   error => {
                //     this.message = 
                //       (error.response && error.response.data) ||
                //       error.message ||
                //       error.toString();
                //     this.successful = false;
                //     console.log("error register: ", error.response)
                //     console.log("Form: ", formData)
                //   }
                // );
                } else{
                    this.loading = false
                }
            });
        },
        backStep(){
            this.loading2 = false
            $('#termsModal').modal('show')
            $('#privacyModal').modal('hide') 
        },
        nextStep(){
            this.loading2 = false
            $('#termsModal').modal('hide')
            $('#privacyModal').modal('show')
        },
        postData(){
            this.loading2 = true
            var url = window.location.origin+process.env.VUE_APP_PUBLIC_PATH+`login`

            let first_name = this.first_name
            let last_name = this.last_name
            // let name = this.name
            let username = this.username
            let email = this.email
            let password = this.password
            let referral_code = this.referral_code
            
            const data = new FormData()
            data.append('first_name', first_name)
            data.append('last_name', last_name)
            // data.append('name', name)
            data.append('username', username)
            data.append('email', email)
            data.append('password', password)
            data.append('referral_code', referral_code)
            
            axios.post(`investor/registration/?verification_redirect_success=${url}&verification_redirect_fail=${url}`, data)
            .then(result => {
                this.success = result.data.message
                this.successful = true
                this.submitted = false;
                // console.log(result)
                this.loading = false;
                this.loading2 = false;
                $('#privacyModal').modal('hide')
                this.first_name = ''
                this.last_name = ''
                // this.name = ''
                this.username = ''
                this.email = ''
                this.password = ''
                this.password_confirmation = ''
                this.referral_code = ''
                // console.log('Regitered: ', result)
                localStorage.setItem('resend_id', result.data.data.id)
                // setTimeout(() => {
                //     this.$router.push('login')
                // }, 3000)
            }).catch((error) => {
                this.loading = false;
                // this.message = 
                // (error.response && error.response.data) ||
                // error.message ||
                // error.toString();
                this.successful = false;
                if (error.status === 400) {
                    this.loading = false
                    this.loading2 = false
                    $('#termsModal').modal('hide')
                    $('#privacyModal').modal('hide')
                }
                this.validation = error.data.data
                // console.log(error.response)
            })
        }
    }
}
</script>
<style scoped>
::v-deep 
.modal-dialog-scrollable .modal-body{
    height: fit-content !important;
}
.div-modal{
    overflow-y: scroll !important;
    max-height: 300px !important;
}
::v-deep .modal-body .language {
    float: left;
    line-height: 1.5;
    margin-top: 10px;
}
.language p{
    color: #727272;
    margin: 0 5px;
    text-decoration: underline;
    cursor: pointer;
}
.language p:hover{
    color: #727272;
}

.activecountry{
    color: blue !important;
}
.activecountry:hover{
    color: blue !important;
}
::v-deep 
.modal-dialog-scrollable .modal-content{
    height: fit-content;
}
ol {
  counter-reset: item
}
li {
  display: block
}
li:before {
  content: counters(item, ".") " ";
  counter-increment: item
}
</style>
<style>
.referral_input{
    text-transform: uppercase;
}
.resend{
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
}
.spacer-md{
    height: 40px;
}
.capitalize{
    text-transform: capitalize;
}
@media(max-width: 767.98px){
    .spacer-md{
        height: 20px;
    }
}
</style>